import Vue from 'vue'
import Vuex from 'vuex'

import mapvessel from '@/store/modules/mapvessel'
import organization from '@/store/modules/organization'
import organizationrole from '@/store/modules/organizationrole'
import roleinorganization from '@/store/modules/roleinorganization'
import roleinvessel from '@/store/modules/roleinvessel'
import user from '@/store/modules/user'
import userprofile from '@/store/modules/userprofile'
import vessel from '@/store/modules/vessel'
import vesselposition from '@/store/modules/vesselposition'
import vesselrole from '@/store/modules/vesselrole'

Vue.use(Vuex)

const map = {
  state: {
    show: true,
    showPaths: false,
    isLoadingPaths: false,
    mapProvider: 'windy',
    isLoadingVessel: false,
    collapsed: false
  },
  mutations: {
    mapSetShow(state, val) {
      state.show = val
    },
    mapSetShowPaths(state, val) {
      state.showPaths = val
    },
    mapSetIsLoadingPaths(state, val) {
      state.isLoadingPaths = val
    },
    mapSetMapProvider(state, val) {
      state.mapProvider = val
    },
    mapSetIsLoadingVessel(state, val) {
      state.isLoadingVessel = val
    },
    mapSetCollapsed(state, val) {
      state.collapsed = val
    }
  }
}

export default new Vuex.Store({
  modules: {
    mapvessel,
    organization,
    organizationrole,
    roleinorganization,
    roleinvessel,
    user,
    userprofile,
    vessel,
    vesselposition,
    vesselrole,
    map
  }
})
